<template>
  <thank-you-stepper-base
    image-src="img/svg/thank-you.svg"
    image-container-class="img-container mt-1"
    image-class="image"
    title="Awesome"
    title-align="center"
    title-class="text-center mt-3"
    message="You have successfully Created User."
    message-class="font-weight-bold text-center"
    use-card
    :use-row-action="false"
    action-wrapper-class="button-wrapper my-2"
    action-button-class=""
    button-text="Done"
    button-btn-color="primary"
    @done="$emit('done')"
  />
</template>
<script>
import ThankYouStepperBase from "@/components/Common/ThankYouStepperBase.vue";

export default {
  name: "ThankYou",
  components: {
    ThankYouStepperBase,
  },
};
</script>
<style scoped>
.img-container {
  display: flex;
  justify-content: center;
}
.image {
  height: 300px;
}
</style>
